import { styled } from '../ui/muiReexports';
export const TableScrollerBox = styled('div')({
    height: '100%',
    position: 'absolute',
    top: '0px',
    width: '100%',
    overflow: 'auto',
});
